import { getAccounts, deleteAccount } from './cloud-account-data';

export const WAIT_INIT_ACCOUNTS = 'WAIT_INIT_ACCOUNTS';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_ACCOUNTS_SUCCESS = 'GET_ACCOUNTS_SUCCESS';
export const GET_ACCOUNTS_FAIL = 'GET_ACCOUNTS_FAIL';
export const DELETE_CLOUD_ACCOUNT = 'DELETE_CLOUD_ACCOUNT';
export const DELETE_CLOUD_ACCOUNT_SUCCESS = 'DELETE_CLOUD_ACCOUNT_SUCCESS';
export const DELETE_CLOUD_ACCOUNT_FAIL = 'DELETE_CLOUD_ACCOUNT_FAIL';

export const forwardAccountList = () => (dispatch) => {
    dispatch({
        type: WAIT_INIT_ACCOUNTS
    });
}

export const getAccountsData = (idToken) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getAccounts(resolve, reject, idToken);
    });

    doPost
    .then((data) => {
        if ('Success' === data.message) {
            let accounts = data.users;
            
            dispatch({
                type: GET_ACCOUNTS_SUCCESS,
                params: {
                    accounts: accounts
                }
            });
        } else {
            dispatch({
                type: GET_ACCOUNTS_FAIL,
                params: {
                    errMsg: data.message
                }
            });
        }        
    }).catch((err) => {
        dispatch({
            type: GET_ACCOUNTS_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: GET_ACCOUNTS
    });
};

export const removeAccount = (idToken, reqBodyObj, accounts) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteAccount(resolve, reject, idToken, reqBodyObj);
    });

    doPost
    .then((data) => {
        const msg = data.message;
        if (msg === 'Success') {
            let newAccounts = [];
            accounts.forEach(account => {
                if (account.uid !== reqBodyObj.uid) {
                    newAccounts.push(account);
                }
            });

            dispatch({
                type: DELETE_CLOUD_ACCOUNT_SUCCESS,
                params: {
                    accounts: newAccounts
                }
            });
        } else {
            dispatch({
                type: DELETE_CLOUD_ACCOUNT_FAIL,
                params: {
                    errMsg: msg
                }
            });
        }
    })
    .catch((err) => {
        dispatch({
            type: DELETE_CLOUD_ACCOUNT_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: DELETE_CLOUD_ACCOUNT
    });
}